import { render, staticRenderFns } from "./VPmNotes.vue?vue&type=template&id=72e96d6a&scoped=true&"
import script from "./VPmNotes.vue?vue&type=script&lang=js&"
export * from "./VPmNotes.vue?vue&type=script&lang=js&"
import style0 from "./VPmNotes.vue?vue&type=style&index=0&id=72e96d6a&scoped=true&lang=css&"
import style1 from "./VPmNotes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e96d6a",
  null
  
)

export default component.exports